// src/pages/Login.jsx

import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Snackbar,
  Alert,
  Paper,
} from "@mui/material";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import API from "../api";
import { getToken, getRole, setAuth } from "../utils/auth";

const Login = () => {
  const token = getToken();
  const role = getRole();
  const navigate = useNavigate();
  const location = useLocation();

  const [form, setForm] = useState({ email: "", password: "" });
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Clear form any time we hit this page
  useEffect(() => {
    setForm({ email: "", password: "" });
  }, [location.pathname]);

  // If already logged in, redirect
  if (token) {
    return <Navigate to={`/${role}`} replace />;
  }

  const showSnackbar = (message, severity = "success") => {
    setSnack({ open: true, message, severity });
  };

  const handleLogin = async () => {
    if (!form.email || !form.password) {
      return showSnackbar("Please enter both email and password", "warning");
    }
    try {
      const { data } = await API.post("/login", form);
      showSnackbar("Login successful", "success");
      setTimeout(() => {
        setAuth(data.token, data.role, data.email, data.mobile, data.id);
        navigate(`/${data.role}`);
      }, 500);
    } catch (err) {
      const msg = err.response?.data?.message || "Login failed";
      console.log(err);
      showSnackbar(msg, "error");
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
    >
      <Paper elevation={4} sx={{ padding: 4, width: 350 }}>
        <Typography variant="h5" mb={2} align="center">
          Login
        </Typography>

        <TextField
          fullWidth
          label="Email"
          type="email"
          value={form.email}
          onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          label="Password"
          type="password"
          value={form.password}
          onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
          sx={{ mb: 1 }}
        />

        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography
            variant="body2"
            sx={{ cursor: "pointer", color: "primary.main" }}
            onClick={() => navigate("/forgot-password")}
          >
            Forgot Password?
          </Typography>
          <Typography
            variant="body2"
            sx={{ cursor: "pointer", color: "primary.main" }}
            onClick={() => navigate("/signup")}
          >
            Sign Up
          </Typography>
        </Box>

        <Button fullWidth variant="contained" onClick={handleLogin}>
          Login
        </Button>
      </Paper>

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
      >
        <Alert severity={snack.severity}>{snack.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default Login;
